import React from "react";

export const RoleContext = React.createContext();